// Generated by purs version 0.15.15
import * as Control_Applicative from "../Control.Applicative/index.js";
import * as Data_Eq from "../Data.Eq/index.js";
import * as Data_Ord from "../Data.Ord/index.js";
import * as Data_Show from "../Data.Show/index.js";
import * as Ouroboros_TsBridge_Branding from "../Ouroboros.TsBridge.Branding/index.js";
import * as Simple_JSON from "../Simple.JSON/index.js";
import * as TsBridge_Monad from "../TsBridge.Monad/index.js";
import * as Untagged_TypeCheck from "../Untagged.TypeCheck/index.js";
var pure = /* #__PURE__ */ Control_Applicative.pure(TsBridge_Monad.applicativeTsBridgeM);
var DocumentUploadFile = function (x) {
    return x;
};
var tsBridgeDocumentUploadFil = {
    tsBridge: function (v) {
        return pure(Ouroboros_TsBridge_Branding.brandedStringType("DocumentUploadFile")("__brandDocumentUploadFile"));
    }
};
var writeDocumentUploadFile = Simple_JSON.writeForeignString;
var unwrap = function (v) {
    return v;
};
var showDocumentUploadFile = Data_Show.showString;
var readDocumentUploadFile = Simple_JSON.readString;
var ordDocumentUploadFile = Data_Ord.ordString;
var newtypeDocumentUploadFile = {
    Coercible0: function () {
        return undefined;
    }
};
var makeDocumentUploadFile = DocumentUploadFile;
var hasRuntimeTypeDocumentUploadFile = Untagged_TypeCheck.hasRuntimeTypeString;
var eqDocumentUploadFile = Data_Eq.eqString;
export {
    DocumentUploadFile,
    makeDocumentUploadFile,
    unwrap,
    newtypeDocumentUploadFile,
    eqDocumentUploadFile,
    ordDocumentUploadFile,
    showDocumentUploadFile,
    readDocumentUploadFile,
    writeDocumentUploadFile,
    hasRuntimeTypeDocumentUploadFile,
    tsBridgeDocumentUploadFil
};
//# sourceMappingURL=index.js.map
